'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RetailPriceListController = function () {
  function RetailPriceListController(authService, appConfig, loadingService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, RetailPriceListController);
    if (!authService.authData.isAdmin) {
      return;
    }

    this.loadingService = loadingService;
    this.uploadUrl = appConfig.apiServiceBaseUri + 'api/file/uploadRetailPriceList';

    this.notification = {
      type: '',
      msg: ''
    };
  }

  (0, _createClass3.default)(RetailPriceListController, [{
    key: 'showUploading',
    value: function showUploading() {
      var ctrl = this;

      this.notification = {
        type: '',
        msg: ''
      };

      ctrl.loadingService.showLoading('retailPriceListUpload', 'Uploading Media Item(s)');
    }
  }, {
    key: 'showError',
    value: function showError(response) {
      var ctrl = this;

      if (response.status === 500) {
        ctrl.notification = {
          type: 'error',
          msg: response.data.exceptionMessage
        };
      } else {
        ctrl.notification = {
          type: 'error',
          msg: 'Something went wront'
        };
      }

      ctrl.loadingService.hideLoading('retailPriceListUpload', 'Uploading Media Item(s)');
    }
  }, {
    key: 'onCsvUploadSuccess',
    value: function onCsvUploadSuccess(response) {
      var ctrl = this;
      ctrl.retailPriceList = response.data;

      ctrl.notification = {
        type: 'success',
        msg: 'Retail Price List updated successfully'
      };

      ctrl.loadingService.hideLoading('retailPriceListUpload', 'Uploading Media Item(s)');
    }
  }]);
  return RetailPriceListController;
}();

exports.default = RetailPriceListController;


// WEBPACK FOOTER //
// ./client/app/components/admin/retailPriceList/retailPriceList.controller.js